import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Config from "../../../../config";
import moment from "moment";

const PaymentSuccessBanner = () => {
  const { authProfile } = useSelector((state) => state.application);
  const { t } = useTranslation();

  const subHeading = React.useMemo(() => {
    if (isEmpty(authProfile)) {
      return "";
    }
    const { PROFILE_STATUS } = Config;
    if (
      isEmpty(authProfile.firstPublishedAt) ||
      isEmpty(authProfile.publishedAt) ||
      authProfile.status === PROFILE_STATUS.IN_REVIEW
    ) {
      return t("payment.adHasBeenSubmittedReview");
    }
    const firstPublishedAt = moment(authProfile.firstPublishedAt);
    const publishedAt = moment(authProfile.publishedAt);
    if (!publishedAt.isAfter(firstPublishedAt)) {
      return t("payment.adHasBeenSubmittedReview");
    }
    return t("payment.adHasBeenRenewed");
  }, [authProfile, t]);

  return (
    !isEmpty(authProfile) && (
      <Grid
        item
        container
        direction="row"
        className="payment-success-banner column-gap-8"
      >
        <i className="far fa-check-circle fa-2x" align="center"></i>
        <Grid item container direction="column" xs>
          <Typography className="typography-body-1">
            {t("payment.paymentSuccess")}
          </Typography>
          <Typography className="typography-body-2">{subHeading}</Typography>
        </Grid>
      </Grid>
    )
  );
};

export default PaymentSuccessBanner;
